import { render, staticRenderFns } from "./SystemWalletView.vue?vue&type=template&id=14478bee"
import script from "./SystemWalletView.vue?vue&type=script&lang=js"
export * from "./SystemWalletView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports